import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '../../hooks/useOnlineStatus'

export function OfflineNotice() {
  const isOnline = useOnlineStatus()

  if (isOnline) return null

  return (
    <div className="mx-auto max-w-lg mb-4 animate-fade-in">
      <div className="flex items-center gap-2 rounded-xl bg-warning-orange/15 border border-warning-orange/20 px-4 py-2.5 text-sm text-warning-orange">
        <WifiOff className="w-4 h-4 shrink-0" />
        <span>Sem conexão — os dados exibidos podem estar desatualizados</span>
      </div>
    </div>
  )
}
